import { createSlice } from "@reduxjs/toolkit";

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    //checkInDate: '01 Dec 2021',
    checkInDate: null,
    checkOutDate: null,
    accommNights: 0,
    programDays: 0,
    totalRooms: 1,
    totalGuests: 1,
    guest1Returning: false,
    guest1ReturningEmail: "",
    guest2Returning: false,
    guest2ReturningEmail: "",
    datesConfirmed: false,
    dateCalendarTouched: false,
  },
  reducers: {
    setAccommNightsProgramDays(state, action) {
      const info = action.payload;
      state.accommNights = info.accommNights;
      state.programDays = info.programDays;
    },
    setDateCalendarTouched(state, action) {
      const dateTouched = action.payload;
      state.dateCalendarTouched = dateTouched.dateCalendarTouched;
    },
    setBookingDates(state, action) {
      const bookingDates = action.payload;
      state.checkInDate = bookingDates.checkIn;
      state.checkOutDate = bookingDates.checkOut;
    },
    setTotalGuestsAccommodation(state, action) {
      const accomGuests = action.payload;
      state.totalRooms = accomGuests.totalRooms;
      state.totalGuests = accomGuests.totalGuests;
    },
    toggleDatesConfirmed(state) {
      state.datesConfirmed = !state.datesConfirmed;
    },
    setGuest1Returning(state, action) {
      const returning = action.payload;
      state.guest1Returning = returning.guest1Returning;
      state.guest1ReturningEmail = returning.guest1ReturningEmail;
    },
    setGuest1ReturningToggle(state) {
      state.guest1Returning = !state.guest1Returning;
      state.guest1ReturningEmail = "";
    },
    setGuest2Returning(state, action) {
      const returning = action.payload;
      state.guest2Returning = returning.guest2Returning;
      state.guest2ReturningEmail = returning.guest2ReturningEmail;
    },
    setGuest2ReturningToggle(state) {
      state.guest2Returning = !state.guest2Returning;
      state.guest2ReturningEmail = "";
    },
    setGuestPlusClicked(state) {
      if (state.totalGuests === 1) {
        state.totalGuests = 2;
      }
    },
    setGuestMinusClicked(state) {
      if (state.totalGuests === 2) {
        state.totalGuests = 1;
        state.totalRooms = 1;
      }
    },
    setRoomPlusClicked(state) {
      if (state.totalRooms === 1 && state.totalGuests === 2) {
        state.totalRooms = 2;
      }
    },
    setRoomMinusClicked(state) {
      if (state.totalRooms === 2) {
        state.totalRooms = 1;
      }
    },
  },
});

export const bookingActions = bookingSlice.actions;

export default bookingSlice;
